import { createAction, props } from '@ngrx/store';

import { NavMenu } from '../interfaces/nav-menu';

export const loadNavMenus = createAction('[NavMenu] Load NavMenus',
);

export const loadNavMenusSuccess = createAction(
  '[NavMenu] Load NavMenus Success',
  props<{ data: NavMenu[]; }>()
);

export const loadNavMenusFailure = createAction(
  '[NavMenu] Load NavMenus Failure',
  props<{ error: any; }>()
);

export const loadOneNavMenu = createAction('[NavMenu] Load One NavMenu', props<{ id: string; }>());


export const clearNavMenuSaveOk = createAction(
  '[User] Clear NavMenu Saved OK',
);

